import React, { useState } from 'react';
import { SkillSearchBar } from '../../SkillSearchBar';
import { SkillSection } from '../../SkillSection';
import { AddSkillButton } from '../../../views';
import { getNoSkillMessage, getTenant, useProfileSkills } from '../../../hooks';
import { inIframe } from '../../../utils';



const SkillsContainer = ({username, t}) => {

    

    const [
        userEarnedSkillsData,
        userEarnedSkillsDataLoaded,
        highlightedSkillsData,
        highlightedSkillsDataLoaded,
        userSelfReportedSkillsData,
        userSelfReportedSkillsDataLoaded,
        setUserSelfReportedSkillsData,
        setHighlightedSkillsData,
    ] = useProfileSkills(username, getTenant());
    const [searchTerm, setSearchTerm] = useState('');
    return (
        <div className="div-block-502">
            <div className="text-block-272 pr_t">{t('Skills')}</div>
            <div>
                <div className="w-layout-hflex flex-block-22"></div>
                <div className="profile-panels">
                    <div
                        className="ov_panel active"
                        data-name={'skills'}
                        style={{ marginTop: '20px' }}
                    >
                        <SkillSearchBar
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                        />
                        <SkillSection
                            title={t('Earned Skills')}
                            skillsData={userEarnedSkillsData}
                            skillsDataLoaded={userEarnedSkillsDataLoaded}
                            refreshSkills={() => { }}
                            searchTerm={searchTerm}
                            noSkillsMessage={getNoSkillMessage('earned', username)}
                        />
                        <div>
                            {userSelfReportedSkillsDataLoaded && !inIframe() && (
                                <AddSkillButton
                                    skillType="selfReported"
                                    skillsData={userSelfReportedSkillsData}
                                    refreshSkills={setUserSelfReportedSkillsData}
                                />
                            )}

                            <SkillSection
                                title={t('Self-Reported')}
                                skillsData={userSelfReportedSkillsData}
                                skillsDataLoaded={userSelfReportedSkillsDataLoaded}
                                refreshSkills={setUserSelfReportedSkillsData}
                                searchTerm={searchTerm}
                                noSkillsMessage={getNoSkillMessage(
                                    'self-reported',
                                    username
                                )}
                            />
                        </div>

                        <div>
                            {highlightedSkillsDataLoaded && !inIframe() && (
                                <AddSkillButton
                                    skillType="highlighted"
                                    skillsData={highlightedSkillsData}
                                    refreshSkills={setHighlightedSkillsData}
                                />
                            )}
                            <SkillSection
                                title={t('Desired')}
                                skillsData={highlightedSkillsData}
                                skillsDataLoaded={highlightedSkillsDataLoaded}
                                refreshSkills={setHighlightedSkillsData}
                                searchTerm={searchTerm}
                                noSkillsMessage={getNoSkillMessage('desired', username)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SkillsContainer;